import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const LBS_Gad = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='LBS_Gad' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'>
                <center><h2>GAD-7</h2></center>
                <br />
                <b>Over the last 2 weeks, how often have you been bothered by the following problems?</b>
           </p>

           <table>
            <tr>
                <td className='w-750'><span className='eleHeader'>1. Feeling nervous,anxious,or on edge.</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbFeelingNervous_NotAtAll' name='rbFeelingNervous' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbFeelingNervous_Several' name='rbFeelingNervous' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbFeelingNervous_OverHalf' name='rbFeelingNervous' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbFeelingNervous_Nearly' name='rbFeelingNervous' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>2. Not being able to stop or control worrying.</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbNotBeingAbleTo_NotAtAll' name='rbNotBeingAbleTo' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbNotBeingAbleTo_Several' name='rbNotBeingAbleTo' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbNotBeingAbleTo_OverHalf' name='rbNotBeingAbleTo' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbNotBeingAbleTo_Nearly' name='rbNotBeingAbleTo' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>3. Worrying too much about different things.</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbWorryingTooMuchAboutDifferent_NotAtAll' name='rbWorryingTooMuchAboutDifferent' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbWorryingTooMuchAboutDifferent_Several' name='rbWorryingTooMuchAboutDifferent' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbWorryingTooMuchAboutDifferent_OverHalf' name='rbWorryingTooMuchAboutDifferent' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbWorryingTooMuchAboutDifferent_Nearly' name='rbWorryingTooMuchAboutDifferent' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>
                <tr>
                <td className='w-750'><span className='eleHeader'>4. Trouble relaxing</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbTroubleRelaxing_NotAtAll' name='rbTroubleRelaxing' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbTroubleRelaxing_Several' name='rbTroubleRelaxing' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbTroubleRelaxing_OverHalf' name='rbTroubleRelaxing' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbTroubleRelaxing_Nearly' name='rbTroubleRelaxing' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>5. Being so restless that it's hard to sit still</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbBeingSoRestlessThatStill_NotAtAll' name='rbBeingSoRestlessThatStill' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbBeingSoRestlessThatStill_Several' name='rbBeingSoRestlessThatStill' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbBeingSoRestlessThatStill_OverHalf' name='rbBeingSoRestlessThatStill' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbBeingSoRestlessThatStill_Nearly' name='rbBeingSoRestlessThatStill' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>6. Becoming easily annoyed or irritable.</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbBecomingEasilyAnnoyedOr_NotAtAll' name='rbBecomingEasilyAnnoyedOr' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbBecomingEasilyAnnoyedOr_Several' name='rbBecomingEasilyAnnoyedOr' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbBecomingEasilyAnnoyedOr_OverHalf' name='rbBecomingEasilyAnnoyedOr' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbBecomingEasilyAnnoyedOr_Nearly' name='rbBecomingEasilyAnnoyedOr' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>7. Feeling Afraid as if something awful might happen.</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbFeelingAfraidAsIfSomething_NotAtAll' name='rbFeelingAfraidAsIfSomething' className='add-only' value='NotAtAll'/>  Not at all</td>
                <td className='w-187'><input type='radio' id='rbFeelingAfraidAsIfSomething_Several' name='rbFeelingAfraidAsIfSomething' className='add-only' value='SeveralDays'/>  Serveral Days</td>
                <td className='w-187'><input type='radio' id='rbFeelingAfraidAsIfSomething_OverHalf' name='rbFeelingAfraidAsIfSomething' className='add-only' value='OverHalfTheDays'/>  Over half the days</td>
                <td className='w-187'><input type='radio' id='rbFeelingAfraidAsIfSomething_Nearly' name='rbFeelingAfraidAsIfSomething' className='add-only' value='NearlyEveryDay'/>  Nearly every day</td>
                </tr>

                <tr>
                <td className='w-750'><span className='eleHeader'>8. If you checked off any problems, how difficult have these made if for you to do your work, take care of things at home, or get along with other people?</span></td>
            </tr>
            <tr>
                <td className='w-187'><input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficult_NotDifficult' name='rbIfYouCheckedOffAnyProblemsHowDifficult' className='add-only' value='NotDifficultAtAll'/>  Not difficult at all</td>
                <td className='w-187'><input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficult_SomeWhat' name='rbIfYouCheckedOffAnyProblemsHowDifficult' className='add-only' value='SomeWhatDifficult'/>  Somewhat difficult</td>
                <td className='w-187'><input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficult_Very' name='rbIfYouCheckedOffAnyProblemsHowDifficult' className='add-only' value='VeryDifficult'/>  Very difficult</td>
                <td className='w-187'><input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficult_ExtremelyDifficult' name='rbIfYouCheckedOffAnyProblemsHowDifficult' className='add-only' value='ExtremelyDifficult'/>  Extremely difficult</td>
                </tr>

                
           </table>

 


            </div>
        </form>

    )
}  
